module.exports = __webpack_public_path__ + "static/media/PeriodicallyUnpublishProduct.2632fc43.svg";